// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandWholesaleCell_wrapper__lNh9H"};